var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !this.isPopFrame
    ? _c("div", { staticClass: "login_header" }, [
        _c("div", { staticClass: "login_logo" }, [
          _c("a", { attrs: { href: _vm.logoUrl } }, [
            _c("img", {
              attrs: {
                src: _vm.loginSource["logo-" + _vm.setTheme],
                alt: "logo",
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "login_bg" }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }